const { BankAccountPoller } = require('./poll_status');

const initBankAccountForm = () => {
    const $form = $('#new_investors_bank_account_form');

    if (!$form.length) return;

    $form.on('ajax:success', (event, data, status, xhr) => {
        const poller = new BankAccountPoller();
        poller.start();
    });

    $form.on('ajax:error', (event, error, status, xhr) => {
        try {
            const errorData = JSON.parse(error.responseText);
            $.flash('alert', errorData.errors || errorData.message);
        } catch (e) {
            const errorMessage = $form.data('verificationError');
            $.flash('alert', errorMessage);
        }
    });
}

document.addEventListener('DOMContentLoaded', initBankAccountForm);


